import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserInfoComponent } from './user-info/user-info.component';
import { HomeComponent } from './home/home.component';
import { MythingsComponent } from './pages/mythings/mythings.component';
import { GalleryComponent } from './pages/gallery/gallery.component';
import { RegisterComponent } from './pages/register/register.component';
import { LoginComponent } from './pages/login/login.component';
import { LinkBoxComponent } from './link-box/link-box.component';
import { ContactComponent } from './contact/contact.component';
import { AuthGuard } from './auth.guard';
import { WebNameComponent } from './pages/web-name/web-name.component';
import { TodoComponent } from './pages/todo/todo.component';
import { WeblogComponent } from './pages/weblog/weblog.component';
import { CookingComponent } from './pages/cooking/cooking.component';
import { BuyComponent } from './pages/buy/buy.component';
import { CommandComponent } from './pages/command/command.component';
import { MusicTextComponent } from './pages/musictext/musictext.component';
import { PostDetailComponent } from './pages/weblog/post-detail/post-detail.component';
import { AdminMessagesComponent } from './admin-messages/admin-messages.component';

const routes: Routes = [
    { path: 'home', component: HomeComponent },
    { path: 'anything', component: MythingsComponent, canActivate: [AuthGuard], data: { roles: ['admin'] } },
    { path: 'users', component: UserInfoComponent,canActivate: [AuthGuard] , data: { roles: ['admin'] }},
    { path: 'gallery', component: GalleryComponent,canActivate: [AuthGuard], data: { roles: ['admin'] } },

    { path: 'todo', component: TodoComponent, canActivate: [AuthGuard], data: { roles: ['admin', 'editor'] } },
    { path: 'weblog', component: WeblogComponent, canActivate: [AuthGuard], data: { roles: ['admin'] } },

    { path: 'weblog/detail/:id', component: PostDetailComponent , canActivate: [AuthGuard], data: { roles: ['admin'] }},
    { path: 'cook', component: CookingComponent, canActivate: [AuthGuard], data: { roles: ['admin', 'editor'] } },
    { path: 'buy', component: BuyComponent, canActivate: [AuthGuard], data: { roles: ['admin', 'editor'] } },
    { path: 'command', component: CommandComponent, canActivate: [AuthGuard], data: { roles: ['admin'] } },

    { path: 'website', component: WebNameComponent, canActivate: [AuthGuard], data: { roles: ['admin', 'editor'] } },

    { path: 'musicu', component: MusicTextComponent , canActivate: [AuthGuard], data: { roles: ['admin', 'editor'] }},

    { path: 'register', component: RegisterComponent },
    { path: 'login', component: LoginComponent },

  // { path: 'linkbox', component: LinkBoxComponent },

  { path: 'contact', component: ContactComponent },
  { path: 'AdminMessage', component: AdminMessagesComponent },


  { path: '', redirectTo: '/home', pathMatch: 'full' },  // هدایت به صفحه Home به طور پیش‌فرض
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
